// Main Product upsells
class ProductUpsells {
  constructor(parent) {
    if (!parent) {
      return;
    }
    this.parent = parent;
    this.init();
  }

  clickEvent = () => {
    const upsellButtons = this.parent.querySelectorAll('.upsell-btn');
    upsellButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        const upsellItems = this.parent.querySelectorAll('.upsells-item');
        upsellItems.forEach(item => {
          item.classList.remove('selected');
        });

        const upsellItem = e.currentTarget.closest('.upsells-item');
        if (upsellItem) {
          upsellItem.classList.add('selected');
        }

        upsellButtons.forEach(btn => {
          btn.removeAttribute('disabled')
        });

        e.currentTarget.setAttribute('disabled', 'disabled');
      });
    });
  }

  init = () => {
    this.clickEvent();
  }
}

new ProductUpsells(document.querySelector('.product-upsells'));
